import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import App from '../../components/Wrapper';
import SignIn from '../Account/SignIn';
import SignUp from '../Account/SignUp';
import ForgotPw from '../Account/ForgotPassword';
import ChangePw from '../Account/ChangePassword';
import withAuthentication from '../../containers/withAuthentication';
import VehicleContainer from  '../../containers/VehicleContainer';
import FuelEntryContainer from  '../../containers/FuelEntryContainer';
import HomeContainer from  '../../containers/HomeContainer';
import * as routes from '../../constants/routes';
import 'react-router-modal/css/react-router-modal.css'
export default () =>

<Router>
	<App>
		<Route exact={true} path={routes.SIGN_UP} component={SignUp}/>
		<Route exact={true} path={routes.SIGN_IN} component={SignIn}/>
		<Route exact={true} path={routes.FORGOT_PW} component={ForgotPw}/>
		<Route exact={true} path={routes.CHANGE_PW} component={ChangePw}/>
		<Route exact={true} path={routes.ADD_CAR} component={withAuthentication(VehicleContainer)}/>
		<Route exact={true} path={routes.ADD_FUEL} component={withAuthentication(FuelEntryContainer)}/>
		<Route exact={true} path={routes.HOME} component={withAuthentication(HomeContainer)}/>
	</App>
</Router>


// WEBPACK FOOTER //
// ./src/components/Router/index.js